import { Box } from '@energiebespaarders/symbols';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import HybridLink from '~/components/HybridLink';
import useMediaQuery from '~/hooks/useMediaQuery';
import theme from '~/styles/theme';
import type { getCategories_allFaqCategories } from '~/types/generated/cms/getCategories';
import MobileSubNavbar from './MobileSubNavbar';

export const NewLink = styled(HybridLink)`
  color: ${(p: { $isCurrent?: boolean }) => (p.$isCurrent ? theme.colors.green : 'black')};
  font-size: 1rem;
`;

interface SubNavBarProps {
  readonly categories: ReadonlyArray<getCategories_allFaqCategories>;
}

const SubNavbar: React.FC<SubNavBarProps> = ({ categories }) => {
  const isTablet = useMediaQuery('lg');

  const router = useRouter();
  const pathnames = router.asPath.split('/');

  const renderedCategories = categories.filter(c => c.isPrimary === true);

  return (
    <>
      {isTablet ? (
        <MobileSubNavbar categories={renderedCategories} />
      ) : (
        <Box
          justifyContent="flex-end"
          alignItems="center"
          px={4}
          height={60}
          width={[1, 1, 1, 1]}
          display="flex"
          style={{
            background: theme.colors.grayLighter,
            fontSize: theme.type.scale[4],
            fontWeight: 500,
          }}
        >
          <Box display="flex" alignItems="center">
            {renderedCategories.map(c => {
              const isCurrent = pathnames.includes(c.title!.toLowerCase());
              return (
                <Box key={c.id} ml={3}>
                  <NewLink to={`/faq/${c.slug}`} $isCurrent={isCurrent}>
                    {c.title}
                  </NewLink>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </>
  );
};

export default SubNavbar;
